import { useQuery } from '@tanstack/react-query';

import { readPersonalAccountStanding } from '@/lib/api/generated/api';
import type { PersonalAccountStanding } from '@/lib/api/generated/model';

import { identityKeys } from '../queryKeys';

/**
 * Whether a workspace requires the signed-in person's own forge account, and
 * which of its hosts they lack (spec 160 US5). The same answer a move's
 * refusal comes from, so the board's notice and the refusal never disagree.
 *
 * `null` from a service that predates the read (404), or when it cannot be
 * read: the notice is then simply not shown, and a refused move still says it.
 */
export function usePersonalAccountStanding(workspaceId: string) {
  return useQuery<PersonalAccountStanding | null>({
    queryKey: identityKeys.personalAccountStanding(workspaceId),
    queryFn: async ({ signal }) => {
      const response = await readPersonalAccountStanding(workspaceId, {
        signal,
      });
      return response.status === 200 ? response.data : null;
    },
    retry: false,
    refetchOnWindowFocus: true,
  });
}
